import { SHOW_AVAILABLE_DESKTOP_UPDATE_BANNER } from '../actions/desktop';
import createMappedReducer from './utils/createMappedReducer';

export const initialState = { shouldShowDesktopUpdateBanner: false };

export const desktop = createMappedReducer(initialState, {
  [SHOW_AVAILABLE_DESKTOP_UPDATE_BANNER]() {
    return { shouldShowDesktopUpdateBanner: true };
  },
});
